<template>
	<div class="container">
		<div class="row-content">
			<div class="header">
				<span>{{ documentType?.name }} ({{ pageRange }})</span>
				<button class="dropdown" @click="isVisible = !isVisible">
					<ChevronUpIcon v-if="isVisible" class="action-icon" />
					<ChevronDownIcon v-else class="action-icon" />
				</button>
			</div>
			<button class="danger" @click="handleRemoveOption">
				<TrashIcon class="action-icon" />
			</button>
		</div>
		<div class="details-content" v-show="isVisible">
			<p>
				Document Type: <span>{{ documentType?.name || options.documentType || 'Unknown' }}</span>
			</p>
			<p>
				Borrower: <span>{{ borrower?.fullName || options.applicantId || 'Unknown' }}</span>
			</p>
			<p>
				Pages: <span>{{ pageRange }}</span>
			</p>
			<p>
				Borrower Visible: <span>{{ options.applicantViewable ? 'Yes' : 'No' }}</span>
			</p>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { ref, computed } from 'vue';
	import { TrashIcon, ChevronDownIcon, ChevronUpIcon } from '@heroicons/vue/24/solid';
	import { Borrower, ServiceType, SplitDocumentOptions } from '@/models/loans';

	const props = defineProps<{
		options: SplitDocumentOptions;
		documentTypeOptions: ServiceType[];
		borrowers: Borrower[];
		onRemoveOption: (option: SplitDocumentOptions) => void;
	}>();

	const isVisible = ref<boolean>(false);

	const borrower = computed(() => {
		const borrowers = props.borrowers || [];

		if (borrowers && borrowers.length > 0) {
			return borrowers.find((b) => b.id === props.options.applicantId);
		}

		return null;
	});

	const documentType = computed(() => {
		const documentTypeOptions = props.documentTypeOptions || [];

		if (documentTypeOptions && documentTypeOptions.length > 0) {
			return documentTypeOptions.find((b) => b.id === props.options.documentType);
		}

		return null;
	});

	const pageRange = computed(() => `${props.options.startIndex + 1}-${props.options.endIndex + 1}`);

	const handleRemoveOption = () => props.onRemoveOption(props.options);
</script>

<style scoped>
	.container {
		display: flex;
		flex-direction: column;
		padding: 6px;
		border-bottom: 1px dashed #ccc;
		gap: 8px;
	}

	.row-content {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.header {
		display: flex;
		align-items: center;
		gap: 8px;
		text-wrap: wrap;
		margin-bottom: 0;
	}

	.details-content {
		background-color: #f2f2f2;
		border-radius: 4px;
		padding: 2px 12px;
		margin-bottom: 6px;
		text-wrap: wrap;
	}

	.action-icon {
		width: 1rem;
		height: 1rem;
		margin: 4px 0;
	}

	button.danger {
		background-color: white;
		border: 1px solid transparent;
		color: #d50000;
		border-radius: 50%;
	}

	button.danger:hover {
		background-color: #d50000;
		border: 1px solid #d50000;
		color: white;
	}

	.dropdown {
		background-color: white;
		border: 1px solid transparent;
		border-radius: 50%;
	}

	.dropdown:hover {
		background-color: #eee;
		border: 1px solid #eee;
	}

	.details-content p {
		font-weight: 600;
	}

	.details-content p span {
		font-weight: normal;
	}
</style>
